import { Link, useParams } from "react-router-dom";
import React from "react";
import { useTranslation } from "react-i18next";
import "../i18next";

import logoAtmWhite from "../assets/images/Group 2.png";
import linkedinWhite from "../assets/images/linkedin8white.svg";
import { withLang } from "../utils/langPath";

const SUPPORTED_LANGS = ["es", "en"];

const Footer = () => {
  const { t } = useTranslation();
  const { lang: langFromUrl } = useParams();
  const currentLang = SUPPORTED_LANGS.includes(langFromUrl)
    ? langFromUrl
    : "es";

  // Slugs dinámicos, igual que en el Navbar
  const SLUGS =
    currentLang === "es"
      ? {
          us: "nosotros",
          banks: "bancos",
          retail: "retail",
          atms: "cajerosautomaticos",
          school: "school",
          services: "servicios",
          contact: "contactenos",
        }
      : {
          us: "about-us",
          banks: "banks",
          retail: "retail",
          atms: "atms",
          school: "school",
          services: "services",
          contact: "contact",
        };

  return (
    <div className="bg-bgblue pt-4">
      <div className="p-2 md:px-16">
        <br />
        {/* Contenedor principal */}
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex-initial w-1/4 flex flex-col space-y-3">
            <div>
              <img
                src={logoAtmWhite}
                className="h-auto object-cover"
                alt="atm net systems solutions logo"
              />
            </div>
          </div>

          {/* Redes sociales en mobile */}
          <div className="flex-2 flex justify-between px-auto w-1/4 md:hidden">
            <a
              href="https://www.linkedin.com/company/atm-net-system-and-solutions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedinWhite} className="h-8" alt="linkedin" />
            </a>
          </div>

          {/* Menú de enlaces */}
          <div
            className="hidden md:flex-2 md:text-lg md:flex md:justify-around md:px-1 md:pt-8"
            style={{ fontFamily: "Helvetica", fontSize: "14px" }}
          >
            <div className="space-x-12">
              <Link
                to={withLang(currentLang, SLUGS.us)}
                className="text-fontWhite"
              >
                {t("navBar.us")}
              </Link>
              <Link
                to={withLang(currentLang, SLUGS.banks)}
                className="text-fontWhite"
              >
                {t("navBar.banks")}
              </Link>
              <Link
                to={withLang(currentLang, SLUGS.retail)}
                className="text-fontWhite"
              >
                {t("navBar.retail")}
              </Link>
              <Link
                to={withLang(currentLang, SLUGS.atms)}
                className="text-fontWhite"
              >
                {t("navBar.atms")}
              </Link>
              <Link
                to={withLang(currentLang, SLUGS.school)}
                className="text-fontWhite"
              >
                {t("navBar.school")}
              </Link>
              <Link
                to={withLang(currentLang, SLUGS.services)}
                className="text-fontWhite"
              >
                {t("navBar.services")}
              </Link>
              <Link
                to={withLang(currentLang, SLUGS.contact)}
                className="text-fontWhite"
              >
                {t("navBar.contact")}
              </Link>
            </div>
          </div>
        </div>

        <hr className="text-fontWhite my-4" />

        {/* Footer inferior */}
        <div
          className="w-7/8 flex md:flex-row justify-around text-xs md:text-base md:px-6 md:py-4 md:mx-auto"
          style={{ fontFamily: "Helvetica" }}
        >
          <p className="text-fontWhite text-center md:text-left mb-4 md:mb-0">
            {t("footer.rights_reserved")}
          </p>

          <div className="hidden md:flex md:space-x-4">
            <a
              href="https://www.linkedin.com/company/atm-net-system-and-solutions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedinWhite} className="h-8" alt="linkedin" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
